import { render, staticRenderFns } from "./ModalBackupPhotos.vue?vue&type=template&id=5e844528&scoped=true"
import script from "./ModalBackupPhotos.vue?vue&type=script&lang=js"
export * from "./ModalBackupPhotos.vue?vue&type=script&lang=js"
import style0 from "./ModalBackupPhotos.vue?vue&type=style&index=0&id=5e844528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e844528",
  null
  
)

export default component.exports